import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Loader2, Flag, Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AccountRegistrations = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/account/registrations`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      })
      .then((r) => setItems(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="account-registrations">
      <h2 className="font-['Oswald'] text-2xl text-[#F2EDE6] tracking-wider mb-6">
        MY RALLY REGISTRATIONS
      </h2>
      {loading ? (
        <div className="text-center py-12">
          <Loader2 className="w-8 h-8 text-[#E8651A] animate-spin mx-auto" />
        </div>
      ) : items.length === 0 ? (
        <div className="text-center py-12 border border-dashed border-[#2A2A2A]">
          <Flag className="w-12 h-12 text-[#2A2A2A] mx-auto mb-3" />
          <p className="text-[#A19D98] mb-3">You haven't registered for any rallies yet.</p>
          <Link to="/rallies" className="btn-primary inline-flex">Browse Rallies</Link>
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((item) => (
            <div
              key={item.id}
              data-testid={`registration-${item.id}`}
              className="bg-[#0A0A0A] border border-[#2A2A2A] p-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3"
            >
              <div>
                <h3 className="font-['Oswald'] text-[#F2EDE6] tracking-wider">
                  {item.rally_name || 'Rally'}
                </h3>
                <p className="text-[#A19D98] text-sm flex items-center gap-2">
                  <Calendar size={14} />
                  Registered {new Date(item.created_at).toLocaleDateString()}
                </p>
                {item.car_year && (
                  <p className="text-[#A19D98] text-xs mt-1">
                    Bringing: {item.car_year} {item.car_make} {item.car_model}
                  </p>
                )}
              </div>
              {item.rally_id && (
                <Link
                  to={`/rallies/${item.rally_id}`}
                  className="btn-secondary text-sm whitespace-nowrap"
                >
                  View Rally
                </Link>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AccountRegistrations;
